import styled from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const WorkerName = styled(Text).attrs({
  color: ColorV2.Blue3,
  typography: "h5",
})`
  display: block;
  margin-bottom: ${Spacing.md}px;
`;

export const AdjustmentForm = styled.div`
  align-items: end;
  display: grid;
  gap: ${Spacing.sm}px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  > button:last-child {
    grid-column: 1 / -1;
    justify-self: end;
  }

  ${mediaMax.mobile} {
    align-items: stretch;
    grid-template-columns: minmax(0, 1fr);

    > button:last-child {
      grid-column: 1;
    }
  }
`;

export const AdjustmentsSection = styled.section`
  margin-top: ${Spacing.lg}px;
`;

export const AdjustmentsTitle = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
  margin-bottom: ${Spacing.sm}px;
`;

export const AdjustmentList = styled.div`
  border: 1px solid ${ColorV2.Blue6};
  border-radius: ${Radius.lg}px;
  overflow: hidden;
`;

export const AdjustmentListRow = styled.div`
  align-items: center;
  background: ${ColorV2.White};
  border-top: 1px solid ${ColorV2.Blue6};
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(155px, 0.5fr) 88px;

  &:first-child {
    border-top: 0;
  }
`;

export const AdjustmentHeader = styled(AdjustmentListRow)`
  ${TypographyV2.b2}
  background: ${ColorV2.Blue7};
`;

export const AdjustmentListCell = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
  min-width: 0;
  padding: ${Spacing.sm}px ${Spacing.md}px;
`;

export const AmountCell = styled(AdjustmentListCell)`
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  text-align: right;
`;

export const AdjustmentInlineInputWrap = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.xs}px;
  justify-content: flex-end;
  width: 100%;

  input {
    min-width: 0;
  }
`;

export const AmountSign = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
`;

export const AdjustmentActions = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;
  padding-right: ${Spacing.md}px;
  position: relative;
  z-index: 1;
`;

export const IconActionButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 0;

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`;

export const ErrorMessage = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.NegativeRed};
  margin-top: ${Spacing.md}px;
`;
